import React, { useState } from "react";
import "../../css/CRUDModal.css";

const AuthorizationModal = ({ show, handleClose, callApi }) => {
  const [formData, setFormData] = useState({
    approvalStatus: "approve",
    remark: "",
  });
  const [errors, setErrors] = useState({
    approvalStatus: "",
    remark: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handleRadioChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      approvalStatus: e.target.value,
    }));
  };

  const handleBack = () => {
    handleClose();
    handleSetEmptyField();
  };

  const handleSetEmptyField = () => {
    setFormData({
      approvalStatus: "approve",
      remark: "",
    });
    setErrors({});
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let hasError = false;
    const newErrors = { ...errors };

    if (!formData.remark.trim()) {
      newErrors.remark = "Remark is required";
      hasError = true;
    }

    if (hasError) {
      setErrors(newErrors);
      return;
    }

    // Send data to API or parent component
    callApi(formData);

    // Close and reset
    handleSetEmptyField();
    handleClose();
  };

  const isDisabled = false;

  return (
    <>
      {show && (
        <div
          style={{
            position: "fixed",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1061,
          }}
        >
          <div className="modal-dialog" role="document">
            <div
              className="modal-content"
              style={{
                width: "597px",
                borderRadius: "24px",
                padding: "24px",
                backgroundColor: "#FFF",
                border: "1px solid rgba(0, 0, 0, 0.175)",
              }}
            >
              <form onSubmit={handleSubmit}>
                <div
                  className="scoped-modal modal-body"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "24px",
                  }}
                >
                  <div className="row mb-3 mt-3">
                    {/* Content */}
                    <div
                      className="row mb-3 mt-3"
                      style={{
                        width: "100%",
                        display: "flex",
                        flexDirection: "column",
                        gap: "20px",
                        padding: "0px 24px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          gap: "8px",
                          textAlign: "center",
                        }}
                      >
                        <p
                          style={{
                            fontSize: "28px",
                            fontWeight: "700",
                            color: "#1f2937",
                            margin: 0,
                          }}
                        >
                          Are you sure?
                        </p>
                        <p
                          style={{
                            fontSize: "18px",
                            fontWeight: "500",
                            color: "#374151",
                            margin: 0,
                          }}
                        >
                          Do you want to approve or reject the top-up request?
                        </p>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          gap: "32px",
                        }}
                      >
                        <label
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            cursor: "pointer",
                          }}
                        >
                          <input
                            type="radio"
                            name="approval"
                            value="approve"
                            checked={formData.approvalStatus === "approve"}
                            onChange={handleRadioChange}
                            style={{
                              accentColor: "#0ea5e9",
                              width: "18px",
                              height: "18px",
                            }}
                          />
                          <span style={{ fontSize: "16px", color: "#1f2937" }}>
                            Approve
                          </span>
                        </label>

                        <label
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            cursor: "pointer",
                          }}
                        >
                          <input
                            type="radio"
                            name="approval"
                            value="reject"
                            checked={formData.approvalStatus === "reject"}
                            onChange={handleRadioChange}
                            style={{
                              accentColor: "#ef4444",
                              width: "18px",
                              height: "18px",
                            }}
                          />
                          <span style={{ fontSize: "16px", color: "#1f2937" }}>
                            Reject
                          </span>
                        </label>
                      </div>

                      <div className="mb-3">
                        <label
                          htmlFor="remark"
                          style={{
                            fontWeight: 600,
                            fontSize: "15px",
                            color: "#4b5563",
                          }}
                        >
                          Remark<span style={{ color: "red" }}> *</span>
                        </label>
                        <textarea
                          id="remark"
                          name="remark"
                          className="form-control"
                          placeholder="Enter your remarks here..."
                          rows="3"
                          value={formData.remark}
                          onChange={handleInputChange}
                          autoComplete="off"
                        ></textarea>
                        {errors.remark && (
                          <span
                            style={{
                              color: "red",
                              fontSize: "13px",
                              marginTop: "4px",
                              display: "block",
                            }}
                          >
                            {errors.remark}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className="scoped-modal"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    paddingTop: "0px",
                    gap: "16px",
                    borderTop: "1px solid #dee2e6",
                    padding: "1rem 1rem",
                  }}
                >
                  <button
                    type="button"
                    className="btn btn-back"
                    onClick={handleBack}
                    style={{ width: "150px", height: "52px" }}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-submit"
                    style={{
                      width: "150px",
                      height: "52px",
                      cursor: isDisabled ? "not-allowed" : "pointer",
                    }}
                    disabled={isDisabled}
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AuthorizationModal;
